




















import Vue from "vue";
import { ADD_ALERT } from "@/store/modules/AlertModule/mutations";
import { FETCH_UPDATE_PACKAGES_LIST } from "@/store/modules/UpdatePackagesModule/actions";
import { mapActions, mapMutations } from "vuex";

import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";
import { AddUpdatePackageResData } from "@/model/communication/updatePackages/AddUpdatePackageResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { AddUpdatePackageCommand } from "@/model/communication/updatePackages/AddUpdatePackageCommand";

export default Vue.extend({
    data() {
        return {
            addPackageLoading: false,
            files: [],
        };
    },
    methods: {
        ...mapActions([FETCH_UPDATE_PACKAGES_LIST]),
        ...mapMutations([ADD_ALERT]),

        async onSaveClick() {
            if (this.files.length > 0) {
                try {
                    this.addPackageLoading = true;
                    let response: AddUpdatePackageResData = await new AddUpdatePackageCommand(this.files).execute();
                    let addedPackages = null;
                    if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") {
                        if (response.signatureErrors && response.signatureErrors.length) {
                            response.signatureErrors.forEach((packageFilename) => {
                                this[ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("update_packages.signature_error", [packageFilename]), null));
                            });
                        }
                        if (response.alreadyExists && response.alreadyExists.length) {
                            response.alreadyExists.forEach((packageFilename) => {
                                this[ADD_ALERT](new AlertModel(AlertModelType.Warning, this.$t("update_packages.already_exists", [packageFilename]), null));
                            });
                        }
                        if (response.packages && response.packages.size > 0) addedPackages = response.packages;
                    } else {
                        this[ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("update_packages.genericError", [" "]), null));
                    }
                    this.resetSelectedFiles();
                    this.$emit("close", addedPackages);
                    this[FETCH_UPDATE_PACKAGES_LIST]();
                    this.addPackageLoading = false;
                } catch (e) {
                    console.error("Something went wrong sending AddUpdatePackage request ", e);
                    this[ADD_ALERT](new AlertModel(AlertModelType.Error, this.$t("update_packages.genericError", [" "]), null));
                }
            }
        },
        onCancelClick() {
            if (this.files.length > 0) this.files = [];
            this.$emit("close");
        },
        resetSelectedFiles() {
            this.files = [];
        },
    },
});
